var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconImage = function SvgIconImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.125 9.375a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 18.75c0 .966.784 1.75 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18.75V5.25a1.75 1.75 0 0 0-1.75-1.75H3.75A1.75 1.75 0 0 0 2 5.25zM4 5.5v7.836l3.006-3.007a1.75 1.75 0 0 1 2.488 0l4.006 4.007 1.756-1.757a1.75 1.75 0 0 1 2.488 0l.003.004L20 14.836V5.5zm16 13v-.836l-3.5-3.5-1.756 1.757a1.75 1.75 0 0 1-2.488 0L8.25 11.914 4 16.164V18.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconImage;